if(typeof FN == 'undefined') FN = {};


FN.posterShowConstants = {
  'animationTypeOneTime': 'onetime',
  'animationTypeContinuous': 'continuous',
  'scrollingDirectionDown': 'down',
  'scrollingDirectionUp': 'up'
}

FN.posterShow = {
  lastScrollEvent: 0,
  lastScrollEventDirection: false,
  animationStages: [
    { 'at': 0.03, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #start_simple' } } 
    },
    { 'at': 0.04, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationDisplay', 'options': { 'cssSelector': '#scroll-arrow-container', 'initialDisplay': 'block', 'finalDisplay': 'none' } } 
    },
    { 'at': 0.05, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScale', 'options': { 'cssSelector': '#poster-container #line_01', 'initialScale': '0', 'finalScale': '1' } }
    },
    { 'at': 0.08, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationTranslate', 'options': { 'cssSelector': '#poster-container #do_the_work', 'initialX': '9000px', 'finalX': '0px' } }
    },
    { 'at': 0.14, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #focus' } }
    },
    { 'at': 0.16, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScale', 'options': { 'cssSelector': '#poster-container #line_02', 'initialScale': '0', 'finalScale': '1' } }
    },
    { 'at': 0.16, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScale', 'options': { 'cssSelector': '#poster-container #line_03', 'initialScale': '0', 'finalScale': '1' } }
    },
    { 'at': 0.18, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #know_whats_important' } } 
    },
    { 'at': 0.20, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #things_go_wrong' } } 
    },
    { 'at': 0.22, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #solve_problem' } } 
    },
    { 'at': 0.26, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationPosterZoom', 'options': {'finalWidth': false, 'initialWidth': 100 } }
    },
    { 'at': 0.27, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #picture-frame' } }
    },
    { 'at': 0.30, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #find_a_mentor' } } 
    },
    { 'at': 0.32, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #no_shortcuts' } } 
    },
    { 'at': 0.34, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #measure_dont_guess' } } 
    },
    { 'at': 0.36, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #everyone_else' } } 
    },
    { 'at': 0.38, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScale', 'options': { 'cssSelector': '#poster-container #line_04', 'initialScale': '0', 'finalScale': '1' } }
    },
    { 'at': 0.38, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScale', 'options': { 'cssSelector': '#poster-container #line_05', 'initialScale': '0', 'finalScale': '1' } }
    },
    { 'at': 0.39, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #know_yourself' } } 
    },
    { 'at': 0.41, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #want_to_be' } } 
    },
    { 'at': 0.42, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #take_risks' } } 
    },
    { 'at': 0.44, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #admit_when_wrong' } } 
    },
    { 'at': 0.46, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #stay_humble' } } 
    },
    { 'at': 0.47, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #talk_customers' } } 
    },
    { 'at': 0.49, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #stop_networking' } } 
    },
    { 'at': 0.50, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScale', 'options': { 'cssSelector': '#poster-container #line_06', 'initialScale': '0', 'finalScale': '1' } }
    },
    { 'at': 0.50, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScale', 'options': { 'cssSelector': '#poster-container #line_07', 'initialScale': '0', 'finalScale': '1' } }
    },
    { 'at': 0.52, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #for_the_money' } } 
    },
    { 'at': 0.53, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #start_again' } } 
    },
    { 'at': 0.54, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #go_to_market' } } 
    },
    { 'at': 0.55, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #value_your_colleagues' } } 
    },
    { 'at': 0.57, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #persevere' } } 
    },
    { 'at': 0.59, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #fail_fast' } } 
    },
    { 'at': 0.63, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': {
        'action': 'animationOpacity', 'options': { 'cssSelector': '#poster-container #coding_is_an_art-bottom' } } 
    },
    { 'at': 0.64, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationPosition', 'options': { 'cssSelector': '#store-container--mobile', 'animationProperty': 'bottom', 'initialValue': '-100%', 'finalValue': '0%' } }
    },
    { 'at': 0.67, 'id': 'showSceneryTable', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScenery', 'options': { 'cssSelector': '#scenery-container--table', 'animationProperty': 'bottom', 'initialValue': '-1000px', 'finalValue': '0px' } }
    },
    { 'at': 0.73, 'id': 'showSceneryLamp', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScenery', 'options': { 'cssSelector': '#scenery-container--lamp', 'animationProperty': 'right', 'initialValue': '-1000px', 'finalValue': false } }
    },
    { 'at': 0.78, 'id': 'showSceneryBookshelf', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScenery', 'options': { 'cssSelector': '#scenery-container--bookshelf', 'animationProperty': 'left', 'initialValue': '-1000px', 'finalValue': false } }
    },
    { 'at': 0.82, 'id': 'showSceneryComputer', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScenery', 'options': { 'cssSelector': '#scenery-container--computer', 'animationProperty': 'left', 'initialValue': '-1000px', 'finalValue': false } }
    },
    { 'at': 0.86, 'id': 'showStoreInfo', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationScenery', 'options': { 'cssSelector': '#scenery-container--store', 'animationProperty': 'right', 'initialValue': '-1000px', 'finalValue': '0px' } }
    },
    { 'at': 0.86, 'id': '', 'type': FN.posterShowConstants.animationTypeOneTime, 'animation': { 
        'action': 'animationClass', 'options': { 'cssSelector': '#scenery-container--store .social-button', 'cssClass': 'social-button--animated' } }
    },
  ],
  sceneryItems: [
    { 'cssSelector': '#scenery-container--lamp', 'animationId': 'showSceneryLamp', 'widthRelativeToPoster': 0.55, 'bleedSide': 'right' },
    { 'cssSelector': '#scenery-container--computer', 'animationId': 'showSceneryComputer', 'widthRelativeToPoster': 0.80, 'bleedSide': 'left' },
    { 'cssSelector': '#scenery-container--bookshelf', 'animationId': 'showSceneryBookshelf', 'widthRelativeToPoster': 0.50, 'bleedSide': 'left' },
    { 'cssSelector': '#scenery-container--store', 'animationId': 'showStoreInfo', 'widthRelativeToPoster': false }
  ],
  viewPortHeight: 0,
  viewPortWidth: 0,
  posterWidthHeightRatio: 1.4574,
  scrollerHeight: false,
  scrollerOffsetTop: false,

  init: function(){
    if(!FN.posterShow.isCompatibleBrowser()){
      FN.posterShow.showFallback();
      return false;
    }
    
    FN.posterShow.windowWasResized();
    FN.posterShow.animationIntro();
    
    $(window).on('scroll', FN.posterShow.scrollingHasChanged);
    $(window).on('resize', FN.posterShow.windowWasResized);
    $('#scroll-arrow-wrapper').on('click', FN.posterShow.scrollViaClickedArrow);
  },
  
  scrollingHasChanged: function(event){
    var totalScrollingPosition = $(window).scrollTop();
    var scrollingPositionBottom = FN.posterShow.scrollerOffsetTop + FN.posterShow.scrollerHeight - FN.posterShow.viewPortHeight;
    var totalScrollingPercentage = totalScrollingPosition / scrollingPositionBottom;
    
    // determine scrolling direction
    FN.posterShow.lastScrollEventDirection = (FN.posterShow.lastScrollEvent - totalScrollingPercentage < 0) ? FN.posterShowConstants.scrollingDirectionDown : FN.posterShowConstants.scrollingDirectionUp;
    
    // only continue if a little threshold was exceeded when scrolling
    if(Math.abs(FN.posterShow.lastScrollEvent - totalScrollingPercentage) < 0.01){
      // a minimum of 1% of the total scrollingPercentage should happen between invocations
      return false;
    }else{
      FN.posterShow.lastScrollEvent = totalScrollingPercentage;
    }
    
    // cycle through animation stage definitions
    for(var i=0; i<FN.posterShow.animationStages.length; i++){
      var animationStage = FN.posterShow.animationStages[i];
      
      var animationStageCompletion = (totalScrollingPercentage - animationStage.from) / (animationStage.until - animationStage.from);
      var options = {
        'totalScrollingPercentage': totalScrollingPercentage,
        'stageScrollingPercentage': animationStageCompletion,
        'scrollingDirection': FN.posterShow.lastScrollEventDirection
      }
      if('options' in animationStage.animation){
        options.animationOptions = animationStage.animation.options;
      }

      // execute appropriate animation function
      if(animationStage.type === FN.posterShowConstants.animationTypeOneTime){
        // one-time animations
        if(FN.posterShow.lastScrollEventDirection === FN.posterShowConstants.scrollingDirectionDown && totalScrollingPercentage >= animationStage.at ||
           FN.posterShow.lastScrollEventDirection === FN.posterShowConstants.scrollingDirectionUp && totalScrollingPercentage <= animationStage.at){
          var fn = window.FN.posterShow[animationStage.animation.action];
          fn(options);
        }
      
      }else if(animationStage.type === FN.posterShowConstants.animationTypeContinuous){
        // continuous animations
        if(totalScrollingPercentage > animationStage.from && totalScrollingPercentage < animationStage.until){
          // scrolling is within the bounds of this animation stage --> this is the currently active animation stage!
          var fn = window.FN.posterShow[animationStage.animation.action];
          fn(options);
        }else if(totalScrollingPercentage > animationStage.until){
          // scrolling has already passed this animation stage
        
        }else if(totalScrollingPercentage < animationStage.from){
          // scrolling has not yet reached this animation stage
        
        }
      }
    }
  },
  
  /**** 
    Animation functions
  */
  animationIntro: function(){
    // NOTE: this is the only "animationXY" function that is called manually, on loading the page
    $('#start_now').addClass('startDashAnimation');
    $('#start_now path').addClass('startFillAnimation');
  },

  animationOpacity: function(options){
    // animation scenario: show other text items (that were hidden until now)
    var opacity = false;
    if(options['scrollingDirection'] === FN.posterShowConstants.scrollingDirectionDown){
      opacity = 1.0;
    }else{
      opacity = 0.0;
    }
    $(options.animationOptions['cssSelector']).css({'opacity': opacity});
  },
  
  animationTranslate: function(options){
    // animation scenario: show item by moving it into view
    var left = false;
    var opacity = false;    // setting opacity is just for safety; this can be overwritten in CSS, e.g. with "opacity: 1.0 !important"
    if(options['scrollingDirection'] === FN.posterShowConstants.scrollingDirectionDown){
      left = options.animationOptions['finalX'];
      opacity = 1.0;
    }else{
      left = options.animationOptions['initialX'];
      opacity = 0.0;
    }
    $(options.animationOptions['cssSelector']).css({'transform': 'translateX('+ left +')',
                                                    'opacity': opacity });
  },
  
  animationScale: function(options){
    // animation scenario: show item by moving it into view
    var scale = false;
    if(options['scrollingDirection'] === FN.posterShowConstants.scrollingDirectionDown){
      scale = options.animationOptions['finalScale'];
    }else{
      scale = options.animationOptions['initialScale'];
    }
    $(options.animationOptions['cssSelector']).css({'transform': 'scaleX('+ scale +')'});
  },
  
  animationDisplay: function(options){
    // animation scenario: show item by setting "display" attribute
    var display = false;
    if(options['scrollingDirection'] === FN.posterShowConstants.scrollingDirectionDown){
      display = options.animationOptions['finalDisplay'];
    }else{
      display = options.animationOptions['initialDisplay'];
    }
    $(options.animationOptions['cssSelector']).css({'display': display});
  },
  
  animationPosition: function(options){
    // animation scenario: change item position
    if(options['scrollingDirection'] === FN.posterShowConstants.scrollingDirectionDown){
      var cssProperties = {};
      cssProperties[options.animationOptions['animationProperty']] = options.animationOptions['finalValue'];
      $(options.animationOptions['cssSelector']).css(cssProperties);

    }else{
      var cssProperties = {};
      cssProperties[options.animationOptions['animationProperty']] = options.animationOptions['initialValue'];
      $(options.animationOptions['cssSelector']).css(cssProperties);
    }
  },
  
  animationClass: function(options){
    // animation scenario: add/remove CSS class
    var cssClass = false;
    if(options['scrollingDirection'] === FN.posterShowConstants.scrollingDirectionDown){
      $(options.animationOptions['cssSelector']).addClass(options.animationOptions['cssClass']);
    }else{
      $(options.animationOptions['cssSelector']).removeClass(options.animationOptions['cssClass']);
    }
  },
  
  animationPosterZoom: function(options){
    // animation scenario: zoom complete poster
    var zoom = false;
    if(options['scrollingDirection'] === FN.posterShowConstants.scrollingDirectionDown){
      zoom = options.animationOptions['finalWidth'];
      $('#poster-container').css({ 'width': zoom + '%', 'margin-top': '80px'});
    }else{
      zoom = options.animationOptions['initialWidth'];
      $('#poster-container').css({ 'width': zoom + '%', 'margin-top': '0px'});
    }
  },
  
  animationScenery: function(options){
    FN.posterShow.resizeSceneryItems();
    
    if(options['scrollingDirection'] === FN.posterShowConstants.scrollingDirectionDown){
      var cssProperties = {};
      cssProperties[options.animationOptions['animationProperty']] = options.animationOptions['finalValue'];
      $(options.animationOptions['cssSelector']).css(cssProperties);

    }else{
      var cssProperties = {};
      cssProperties[options.animationOptions['animationProperty']] = options.animationOptions['initialValue'];
      $(options.animationOptions['cssSelector']).css(cssProperties);
    }
  },
  
  /**** 
    Helper functions
  */
  scrollViaClickedArrow: function(event){
    var scrollTo = FN.posterShow.scrollerHeight * 0.05;
    $('html, body').animate({
      scrollTop: scrollTo + 'px'
    }, 500);
  },
  
  calculateZoomedOutPosterWidth: function(){
    var finalPosterHeight = FN.posterShow.viewPortHeight * 0.75;
    var initialPosterWidth = FN.posterShow.viewPortWidth;
    var initialPosterHeight = initialPosterWidth * FN.posterShow.posterWidthHeightRatio;
    var finalSizePercentage = (finalPosterHeight / initialPosterHeight) * 100;
    
    for(var i=0; i<FN.posterShow.animationStages.length; i++){
      var animationStage = FN.posterShow.animationStages[i];
      if(animationStage.animation.action === 'animationPosterZoom'){
        animationStage.animation.options.finalWidth = finalSizePercentage;
        break;
      }
    }
  },
  
  resizeSceneryItems: function(){
    // size the scenery items in relation to poster size
    var horizontalSpace = 50;
    var horizontalSpacePercent = (horizontalSpace / FN.posterShow.viewPortWidth) * 100;
    var posterFinalWidthPercent = false;
    var posterFinalWidthPixels = false;

    for(var i=0; i<FN.posterShow.animationStages.length; i++){
      var animationStage = FN.posterShow.animationStages[i];
      if(animationStage.animation.action === 'animationPosterZoom'){
        posterFinalWidthPercent = animationStage.animation.options.finalWidth;
        posterFinalWidthPixels  = (posterFinalWidthPercent / 100) * FN.posterShow.viewPortWidth;
        break;
      }
    }
    
    var spaceBesidesPosterPercent = (100 - posterFinalWidthPercent) / 2;
    
    for(var i=0; i<FN.posterShow.sceneryItems.length; i++){
      var sceneryItem = FN.posterShow.sceneryItems[i];
      var sceneryItemWidth = false;
      var bleed = 0;
      
      if(sceneryItem.animationId === 'showStoreInfo'){
        sceneryItemWidth = spaceBesidesPosterPercent - horizontalSpacePercent;
      }else{
        sceneryItemWidth = posterFinalWidthPercent * sceneryItem.widthRelativeToPoster;

        if(spaceBesidesPosterPercent > (sceneryItemWidth + horizontalSpacePercent)){
          bleed = 0;
        }else{
          bleed = (sceneryItemWidth - spaceBesidesPosterPercent) + horizontalSpacePercent;
        }
      }
      
      // set width on item
      $(sceneryItem.cssSelector).css({'width': sceneryItemWidth + '%'});
      
      // save bleed / horizontal position in the item's animation
      for(var a=0; a<FN.posterShow.animationStages.length; a++){
        var animationStage = FN.posterShow.animationStages[a];
        if(sceneryItem.animationId === animationStage['id']){
          animationStage.animation.options.finalValue = (-1 * Math.abs(bleed)) + '%';
          break;
        }
      }
    }

  },
  
  /** 
    React on Window Resize and Loading
  */
  windowWasResized: function(event){
    FN.posterShow.viewPortHeight    = $(window).height();
    FN.posterShow.viewPortWidth     = $(window).width();
    FN.posterShow.scrollerHeight    = $('#poster-scroller').height();
    FN.posterShow.scrollerOffsetTop = $('#poster-scroller').offset().top;
    
    FN.posterShow.calculateZoomedOutPosterWidth();
  },
  
  /**
    Check for incompatible browsers
  */
  isCompatibleBrowser: function(){
    var isIE_11 = !!window.MSInputMethodContext && !!document.documentMode;     // Internet Explorer 11
    var isIE_6_10 = !!window.ActiveXObject;                                     // Internet Explorer 6 - 10

    if(isIE_11 || isIE_6_10){
      return false;
    }else{
      return true;
    }
  },
  
  showFallback: function(){
    var posterURL = $('.fallback__poster-container').attr('data-image');
    var posterContent = '<img src="' + posterURL + '">';
    $('.fallback__poster-container').prepend(posterContent);

    $('#poster-scroller').hide();
    $('#stage').hide();
    $('#fallback').show();
  }
};






FN.startupManifesto = {
  showNewsletterSignup: function(){
    $('.newsletter-form').show();
    $('.newsletter-form input[type="text"]').focus();
  }
};


FN.popupConfig.addPopupConfig({
  'id': 'fn-popup_incentive_startupmanifesto',
  'type': 'modal',
  'active': true,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onClick',
    'selector': '.button--incentive_startupmanifesto',
    'showOnlyOnce': false
  },
  'content': [
    { 'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">Download the Wallpaper<span class="fn-popup__text--tag">Free</span></h2><p class="fn-popup__text--subline">Get a set of awesome wallpapers for your desktop!</p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/specialsites/startup-manifesto/popup_startupmanifesto.png" /></span>',
      'action-button': 'Get the Wallpaper',
      'signup-medium': 'tower-blog',
      'signup-URI': 'fn-popup_incentive_startupmanifesto',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the wallpaper and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'collectConsent': true},
        { 'id': 'incentive_startupmanifesto', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    }
  ]
});




$(document).ready(function(){
  FN.posterShow.init();
  
  /*********** Configure Analytics Event Tracking */
  var micrositeAnalyticsEvents = [
    /* Newsletter Subscription */
    { 'config': { 'selector': '.newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'developer-manifesto' }
    },
    /* Page Links */
    { 'config': { 'selector': '.button--store.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'developer-manifesto/stuff-store' }
    },
    { 'config': { 'selector': '.social-button--about.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'developer-manifesto/tower-website' }
    },
    /* Social Share */
    { 'config': { 'selector': '.social-button--twitter.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'developer-manifesto/twitter' }
    },
    { 'config': { 'selector': '.social-button--facebook.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'developer-manifesto/facebook' }
    },
    { 'config': { 'selector': '.social-button--linkedin.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'developer-manifesto/linkedin' }
    },
    /* Content Downloads */
    { 'config': { 'selector': '.content-download-link.analytics--click' },
      'event':  { 'eventCategory': 'content', 'eventAction': 'download', 'eventLabelSuffix': 'startup-manifesto-wallpapers' }
    }
  ];
  FN.analytics.addConfiguredEvents(micrositeAnalyticsEvents);


  /*********** prefill "source[OS]" value in newsletter forms */
  if($('input[name="signup[OS]"]').length > 0){
    $('input[name="signup[OS]"]').val(FN.helpers.platform());
  }

  /*********** newsletter subscription */
  $('.' + FN.newsletterConfig.selectors.formClass).each(function(index, element){
    FN.newsletterConfig.instances.push(new FN.newsletter(element));
  });

});
